import {OverlayState} from "@/hooks/common/useOverlay";
import {getTarget} from "@COMPONENTS/common/commonUtil";
import * as style from "@COMPONENTS/style/common/categoryToastM";
import useGlobalMenu from "@QUERIES/bff/global/useGlobalMenu";
import {device} from "@yb/utils";
import {useRouter} from "next/router";
import {useEffect, useRef, useState} from "react";

const Category = (overlayProps: OverlayState) => {
	const router = useRouter();

	/** 메뉴 관련 */
	const globalMenu = useGlobalMenu().data?.body;
	const {menuLv2List, menuLv3List} = globalMenu;
	const menu = [...menuLv2List, ...menuLv3List];

	const queryDspSid = (router.query?.dspSid as string) || "";
	const dspSidHi = menu.find(o => o.dspSid === queryDspSid)?.dspSidHi || "";
	// lv3List
	const categoryList = menu.filter(o => o.dspSidHi === dspSidHi && o.mobileYn === "Y");

	const lv2DspNm = menuLv2List.find(o => o.dspSid === dspSidHi).dspNm || "";

	/** publish */
	const [show, setShow] = useState(true);
	const [animate, setAnimate] = useState(show);
	const wrapRef = useRef<HTMLDivElement>(null);

	const popupClose = () => {
		setShow(false);
	};

	useEffect(() => {
		if (!animate && wrapRef.current) {
			wrapRef.current.addEventListener("animationend", popupClose);
			return () => {
				if (!animate && wrapRef.current) {
					wrapRef.current.removeEventListener("animationend", popupClose);
				}
			};
		}
	}, [show, animate, wrapRef]);

	useEffect(() => {
		if (show && document.body) {
			document.body.style.overflowY = "hidden";
			document.body.style.touchAction = "none";
		}
		return () => {
			document.body.style.removeProperty("overflow-y");
			document.body.style.removeProperty("touch-action");
		};
	}, [show]);

	const handleClick = (mdspUrl: string, mwebMenuTarget: string) => {
		const target = getTarget(mwebMenuTarget);
		if (device.isYBApp() && target === "_blank") {
			const encodedUrl = encodeURIComponent(mdspUrl);
			location.href = `ybtour://openBrowser?url=${encodedUrl}`;
		} else {
			window.open(mdspUrl, target);
		}
	};

	return (
		<style.PopupWrap ref={wrapRef} data-show={String(show)} animate={animate} show={show}>
			<style.PopupDimm onClick={() => setAnimate(!show)} />
			<style.PopupContainer>
				<style.PopupHeader>
					<h3>{lv2DspNm}</h3>
					<style.PopupCloseButton onClick={() => setAnimate(!show)}>
						<span>창 닫기</span>
					</style.PopupCloseButton>
				</style.PopupHeader>
				<style.PopupArea>
					<ul>
						{categoryList.length &&
							categoryList.map(category => {
								const {dspSid, dspNm, mdspUrl, mwebMenuTarget} = category;
								return (
									<li key={dspSid}>
										<style.RadioWrap>
											<input
												type="radio"
												id={dspSid}
												name="category"
												defaultChecked={dspSid === queryDspSid}
												onClick={() => handleClick(mdspUrl, mwebMenuTarget)}
											/>
											<label htmlFor={dspSid}>{dspNm}</label>
										</style.RadioWrap>
									</li>
								);
							})}
					</ul>
				</style.PopupArea>
			</style.PopupContainer>
		</style.PopupWrap>
	);
};

export default Category;
